var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.connections.current)?_c('div',{staticClass:"ui-app"},[_c('UiSidebar'),_c('main',{staticClass:"ui-main"},[_c('UiHeader'),_c('section',{staticClass:"ui-content"},[_c('router-view')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }